

import { lazy } from "react";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

const ApprovalList = lazy(() => import("../components/approvalList"));
const ApprovalView = lazy(() => import("../components/approvalView"));

const employeeApprovalRoute = [

  {
    icon: VerifiedUserIcon,
    name: "Approval Request",
    link: "/approval-request",
    path: "approval-request",
    index: 19,
    element: <ApprovalList />,
    superAdminView: false,
    permission: "Approval Request-Read",
  },
  {
    path: "/approval-request/:id",
    element: <ApprovalView />,
  },
];
export default employeeApprovalRoute;
